(() => {
  const init = () => {
    document.querySelectorAll('.ffhome-values-grid,.ffpage-values-grid,.ffpage-steps,.ff-card-grid,.ffc-grid,.ffpage-shop__rail').forEach((track, index) => {
      if (track.dataset.mobileCarousel) return;
      track.dataset.mobileCarousel = 'true';
      if (!track.id) track.id = 'ff-mobile-rail-' + index;
      track.tabIndex = 0;
      const steps = track.classList.contains('ffpage-steps');
      track.setAttribute('aria-label', steps ? 'How it works steps' : track.className.includes('values') ? 'Our values' : 'Holiday porch edits');

    });
    document.querySelectorAll('.ff-card-grid,.ffc-grid,.ffpage-shop__rail').forEach(rail => {
      if (rail.dataset.aligned) return;
      rail.dataset.aligned = 'true';
      const cards = Array.from(rail.querySelectorAll(':scope > article'));
      if (!cards.length || typeof cards[0].getBoundingClientRect !== 'function') return;
      const align = () => {
        cards.forEach(card => {card.style.minHeight='';const body=card.querySelector('.ff-edit-card__body');if(body)body.style.minHeight='';});
        const groups = [cards.map(c => c.querySelector('.ff-product-card__copy > h3,.ffc-copy > h2,article > div > h3')), cards.map(c => c.querySelector('.ff-price,.ffc-price,.ffpage-price')), cards.map(c => c.querySelector('.ff-product-card__copy > p:not(.ff-card-label):not(.ff-price),.ffc-copy > p:not(.ff-card-label):not(.ffc-price),article > div > p:not(.ff-card-label):not(.ffpage-price)'))];
        const count = Math.max(...cards.map(c => c.querySelectorAll('.ff-card-details li').length));
        for (let row = 0; row < count; row++) groups.push(cards.map(c => c.querySelectorAll('.ff-card-details li')[row]));
        groups.forEach(group => {const nodes=group.filter(Boolean);nodes.forEach(n => n.style.minHeight='');const height=Math.max(0,...nodes.map(n => n.getBoundingClientRect().height));nodes.forEach(n => n.style.minHeight=height+'px');});
        cards.forEach(card => card.style.minHeight='');
        const cardHeight=Math.max(0,...cards.map(card => card.getBoundingClientRect().height));
        cards.forEach(card => card.style.minHeight=cardHeight+'px');
        const bodies=cards.map(card => card.querySelector('.ff-edit-card__body')).filter(Boolean);
        bodies.forEach(body => body.style.minHeight='');
        const bodyHeight=Math.max(0,...bodies.map(body => body.getBoundingClientRect().height));
        bodies.forEach(body => body.style.minHeight=bodyHeight+'px');

      };
      let timer;
      window.addEventListener('resize', () => {clearTimeout(timer);timer=setTimeout(align,100);});
      rail.querySelectorAll('details').forEach(d => d.addEventListener('toggle',align));
      rail.querySelectorAll('img').forEach(img => img.addEventListener('load',align,{once:true}));
      if(document.fonts)document.fonts.ready.then(align);
      align();
    });
    document.querySelectorAll('.ff-card-grid,.ffc-grid,.ffpage-shop__rail').forEach(rail => {
      if(rail.dataset.initialEditHandled)return;
      rail.dataset.initialEditHandled='true';
      if(typeof window.matchMedia!=='function'||!window.matchMedia('(max-width: 749px)').matches)return;
      const statement=rail.querySelector('[data-edit="statement"]');if(!statement)return;
      let interacted=false;rail.addEventListener('pointerdown',()=>{interacted=true},{once:true});rail.addEventListener('keydown',()=>{interacted=true},{once:true});
      requestAnimationFrame(()=>{if(interacted)return;const box=statement.getBoundingClientRect(),track=rail.getBoundingClientRect();rail.scrollLeft+=box.left-track.left-(rail.clientWidth-box.width)/2;});
    });
    if(typeof URL !== 'undefined' && window.location){
    const shopPath = '/collections/the-holiday-edit';
    const current = new URL(window.location.href);
    const theme = window.Shopify && window.Shopify.theme;
    const preview = current.searchParams.get('preview_theme_id') || (theme && String(theme.role).toLowerCase()==='unpublished' ? String(theme.id) : '');
    const previewHref = (href, hash) => {
      const destination = new URL(href, current.origin);
      if(preview)destination.searchParams.set('preview_theme_id',preview);
      destination.hash=hash;
      return destination.pathname+destination.search+destination.hash;
    };
    document.querySelectorAll('[data-ff-book-now],.announcement-bar__link').forEach(book => {
      const destination=new URL(book.getAttribute('href'),current.origin);
      if(!book.hasAttribute('data-ff-book-now') && (destination.pathname!==shopPath || !/book\s+now/i.test(book.textContent)))return;
      book.setAttribute('href',previewHref(book.getAttribute('href'),'#shop-holiday-edit'));
    });
    // Draft-only routing: global menus remain untouched in Shopify admin.
    document.querySelectorAll('a[href]').forEach(link => {
      const target=new URL(link.getAttribute('href'),current.origin);
      if(target.origin===current.origin && /\/pages\/(custom-edit|corporate)\/?$/.test(target.pathname)){
        link.setAttribute('data-ff-project-link','');
        link.setAttribute('href',shopPath+'#custom-project');
      }
    });
    document.querySelectorAll('[data-ff-project-link]').forEach(link => {
      link.setAttribute('href',previewHref(link.getAttribute('href'),'#custom-project'));
      if(link.dataset.ffProjectLinkReady)return;
      link.dataset.ffProjectLinkReady='true';
      link.addEventListener('click',event => {
        if(event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
        const target=new URL(link.getAttribute('href'),current.origin);
        if(target.pathname===window.location.pathname){const details=document.querySelector('#custom-project details');if(details)details.open=true;}
      });
    });
    document.querySelectorAll('header-drawer a[href]').forEach(link => {
      const destination=new URL(link.getAttribute('href'),current.origin);
      if(destination.origin!==current.origin || destination.pathname!==shopPath || link.textContent.trim().toLowerCase()!=='shop')return;
      link.setAttribute('href',previewHref(link.getAttribute('href'),''));
      if(link.dataset.ffShopTop)return;
      link.dataset.ffShopTop='true';
      link.addEventListener('click',event => {
        if(event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
        const target=new URL(link.href,current.origin);
        if(window.location.pathname===target.pathname){
          event.preventDefault();
          window.history.replaceState(window.history.state,'',target.pathname+target.search);
          const drawer=link.closest('header-drawer');
          if(drawer && typeof drawer.close==='function')drawer.close();
          window.scrollTo({top:0,left:0,behavior:'instant'});
        }else{
          try{window.sessionStorage.setItem('ff-shop-menu-top',JSON.stringify({path:target.pathname,time:Date.now()}));}catch(error){}
        }
      });
    });
    if(!document.documentElement.dataset.ffShopArrival){
      document.documentElement.dataset.ffShopArrival='true';
      let arrival;
      try{arrival=JSON.parse(window.sessionStorage.getItem('ff-shop-menu-top'));window.sessionStorage.removeItem('ff-shop-menu-top');}catch(error){}
      if(arrival && arrival.path===window.location.pathname && !window.location.hash && Date.now()-arrival.time<30000){
        const oldRestoration=window.history.scrollRestoration;
        window.history.scrollRestoration='manual';
        window.scrollTo({top:0,left:0,behavior:'instant'});
        let cancelled=false;
        const stop=()=>{cancelled=true;};
        const events=['pointerdown','touchstart','wheel','keydown'];
        events.forEach(type=>window.addEventListener(type,stop,{once:true,passive:true}));
        const loaded=document.readyState==='complete'?Promise.resolve():new Promise(resolve=>window.addEventListener('load',resolve,{once:true}));
        Promise.all([loaded,document.fonts?document.fonts.ready:Promise.resolve()]).then(()=>requestAnimationFrame(()=>{
          events.forEach(type=>window.removeEventListener(type,stop));
          if(!cancelled)window.scrollTo({top:0,left:0,behavior:'instant'});
          window.history.scrollRestoration=oldRestoration;
        }));
      }
    }
    }
    // A single, scoped correction after fonts/load; never pull someone back after they interact.
    const shopHeading = document.getElementById('shop-holiday-edit');
    if(shopHeading && window.location && window.location.hash==='#shop-holiday-edit' && !shopHeading.dataset.anchorPrepared){
      shopHeading.dataset.anchorPrepared='true';
      let interacted=false;
      const cancel=()=>{interacted=true;};
      const events=['pointerdown','touchstart','wheel','keydown'];
      events.forEach(type=>window.addEventListener(type,cancel,{once:true,passive:true}));
      const loaded=document.readyState==='complete' ? Promise.resolve() : new Promise(resolve=>window.addEventListener('load',resolve,{once:true}));
      Promise.all([loaded,document.fonts ? document.fonts.ready : Promise.resolve()]).then(()=>requestAnimationFrame(()=>{
        events.forEach(type=>window.removeEventListener(type,cancel));
        if(interacted || window.location.hash!=='#shop-holiday-edit')return;
        const hero=document.querySelector('.ffc-split-hero');
        const photo=hero && ((window.matchMedia('(max-width: 749px)').matches ? hero.querySelector('.ff-hero-photo-tile') : null) || hero.querySelector('.ff-desktop-hero__media>img'));
        if(hero && photo){const gap=Math.max(0,hero.getBoundingClientRect().bottom-photo.getBoundingClientRect().bottom);shopHeading.style.setProperty('--ff-shop-image-gap',gap+'px');}
        const inset=parseFloat(getComputedStyle(shopHeading).scrollMarginTop)||0;
        if(Math.abs(shopHeading.getBoundingClientRect().top-inset)>2)shopHeading.scrollIntoView({block:'start',behavior:'auto'});
      }));
    }
    const openProjectFromHash=()=>{if(window.location && window.location.hash==='#custom-project'){const details=document.querySelector('#custom-project details');if(details)details.open=true;}};
    openProjectFromHash();
    if(!document.documentElement.dataset.ffProjectHashReady){document.documentElement.dataset.ffProjectHashReady='true';window.addEventListener('hashchange',openProjectFromHash);}
    document.querySelectorAll('.ff-project-inquiry__disclosure').forEach(details => {
      if(details.dataset.ffProjectReady)return;
      details.dataset.ffProjectReady='true';
      details.addEventListener('toggle',() => {
        if(details.open && document.activeElement===details.querySelector('summary')){
          const heading=details.querySelector('.ff-project-inquiry__fields h3');
          if(heading)heading.focus({preventScroll:true});
        }
      });
    });
    const sticky = document.querySelector('.ff-mobile-shop');
    if(sticky && !sticky.dataset.ready){
      sticky.dataset.ready='true';
      const link=sticky.querySelector('a');
      const rail=document.querySelector('.ffc-grid,.ffpage-shop__rail,.ff-card-grid,#shop .ff-folio-carousel-window');
      const destination=rail || document.querySelector('#shop');
      const current=new URL(window.location.href);
      const target=new URL(destination ? current.href : link.href,current.origin);
      const theme=window.Shopify && window.Shopify.theme;
      const preview=current.searchParams.get('preview_theme_id') || (theme && String(theme.role).toLowerCase()==='unpublished' ? String(theme.id) : '');
      if(preview)target.searchParams.set('preview_theme_id',preview);
      ['ff_address_test','ff_test_cart'].forEach(key=>{if(current.searchParams.has(key))target.searchParams.set(key,current.searchParams.get(key));});
      target.hash='holiday-edit-cards';
      link.href=target.pathname+target.search+target.hash;
      const scrollToCards=()=>{
        if(!destination)return;
        if(!destination.hasAttribute('tabindex'))destination.tabIndex=-1;
        destination.focus({preventScroll:true});
        const header=document.querySelector('#header-component');
        const offset=(header ? header.getBoundingClientRect().height : 0)+16;
        let scroller=destination.parentElement;
        while(scroller && !(scroller.scrollHeight>scroller.clientHeight && /auto|scroll/.test(getComputedStyle(scroller).overflowY)))scroller=scroller.parentElement;
        const top=Math.max(0,(scroller ? scroller.scrollTop : window.scrollY)+destination.getBoundingClientRect().top-(scroller ? scroller.getBoundingClientRect().top : 0)-offset);
        (scroller || window).scrollTo({top,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      link.addEventListener('click',event=>{
        if(!destination || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
        event.preventDefault();
        window.history.replaceState(window.history.state,'',link.href);
        scrollToCards();
      });
      if(destination && current.hash==='#holiday-edit-cards'){
        let interrupted=false;
        const stop=()=>{interrupted=true;};
        const events=['pointerdown','touchstart','wheel','keydown'];
        events.forEach(type=>window.addEventListener(type,stop,{once:true,passive:true}));
        const loaded=document.readyState==='complete' ? Promise.resolve() : new Promise(resolve=>window.addEventListener('load',resolve,{once:true}));
        Promise.all([loaded,document.fonts ? document.fonts.ready : Promise.resolve()]).then(()=>requestAnimationFrame(()=>{
          events.forEach(type=>window.removeEventListener(type,stop));
          if(!interrupted && window.location.hash==='#holiday-edit-cards')scrollToCards();
        }));
      }
      const footer=document.querySelector('footer');
      let queued=false;
      const update=()=>{
        queued=false;
        const active=document.activeElement;
        const inputFocused=active && (active.matches('input,select,textarea') || active.isContentEditable);
        const keyboard=window.visualViewport && window.innerHeight-window.visualViewport.height>120;
        sticky.hidden=!!(inputFocused || keyboard || document.querySelector('dialog[open]') || (footer && footer.getBoundingClientRect().top<window.innerHeight+80));
      };
      const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update);}};
      ['scroll','resize','pageshow'].forEach(type=>window.addEventListener(type,schedule,{passive:true}));
      document.addEventListener('scroll',schedule,{passive:true,capture:true});
      ['focusin','focusout','toggle'].forEach(type=>document.addEventListener(type,schedule,true));
      window.visualViewport?.addEventListener('resize',schedule);
      if(typeof MutationObserver!=='undefined')new MutationObserver(schedule).observe(document.body,{subtree:true,attributes:true,attributeFilter:['open']});
      update();
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

